import React from "react";

import { StyledWrapper, StyledLabel, StyledTooltip, StyledInfoOutline } from "./styles";

const DealCountWithTooltip = ({
  label = "",
  titles = [],
  placement = "right"
}) => (
  <StyledWrapper>
    <StyledLabel>{label}</StyledLabel>
    <StyledTooltip
      placement={placement}
      title={titles.map(title => <div key={title}>{title}</div>)}
    >
      <StyledInfoOutline />
    </StyledTooltip>
  </StyledWrapper>
);

export default DealCountWithTooltip;
